import React from "react";
import PropTypes from 'prop-types';

const HiddenAttrs = ({ userId, applicationId }) =>
  <div className="hidden-attrs">
    <div id="rbbob_userId" style={{ display: "none" }}>
      {userId}
    </div>
    <div id="internal_reference_id" style={{ display: "none" }}>
      {applicationId}
    </div>
  </div>;

HiddenAttrs.propTypes = {
  userId: PropTypes.string,
  applicationId: PropTypes.string
}

HiddenAttrs.defaultProps = {
  userId: '',
  applicationId: ''
}

export default HiddenAttrs;



// WEBPACK FOOTER //
// ./src/shared/HiddenAttrs/index.js